<template>
   <div class="container1">
      <div class="ct-index1">
         <div class="inner1">
            <el-empty description="权限不足">
               <div>您当前IP为：{{ this.$route.query.ip }}，如需开通使用请联系客服QQ：1044423649</div>
            </el-empty>
         </div>
      </div>
      <div>
         <common-foot></common-foot>
      </div>
   </div>
</template>

<script>
import CommonFoot from "common/foot/Foot";
export default {
   name: "Home",
   components: {
      CommonFoot,
   },
   data: function () {
      return {
         
      };
   },
   methods: {

   },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// src/common/Empty.vue